angular.module('unergie.main')
.directive('spinning', () =>
    ({
        restrict: 'A',
        templateUrl: '/directives/spinningbutton/spinningbutton.html',
        transclude: true,
        scope: {
            spinning: '=',
        },
        link($scope, element) {
            return element.addClass('relative')
        },
    }),
)
